import React from 'react';
import {inject, observer} from 'mobx-react';
import {toJS} from 'mobx';

import WeaMenu from '../../../../../../pc4public/portal/wea-menu/';

@inject('portalThemeStore')
@observer
class E9LeftMenu extends React.Component {
    constructor(props) {
        super(props);
        this.onSelect = this.onSelect.bind(this);
    }

    render() {
        const {portalThemeStore} = this.props;
        const {themeInfo, frontEndMenu, leftMenuObj, leftMenuMode} = portalThemeStore;

        const {themeData = {}} = themeInfo;
        const {styleConfig = {}} = themeData;
        const {leftmenu = {}} = styleConfig;
        const fontSize = parseInt(leftmenu.titleFontSize || '12px');

        const {leftMenuSelected = {}} = leftMenuObj;
        const _frontEndMenu = toJS(frontEndMenu);
        const _leftMenuSelected = toJS(leftMenuSelected);
        const _selectedKey = _leftMenuSelected.id;

        return (
            <div className="e9aside-container" style={{display: leftMenuMode == 'inline' ? 'block' : 'none'}}>
                <WeaMenu
                    mode="vertical"
                    needSwitch={false}
                    inlineWidth={197}
                    verticalWidth={65}
                    fontSize={fontSize}
                    datas={_frontEndMenu}
                    defaultSelectedKey={_selectedKey}
                    onSelect={this.onSelect}
                />
            </div>
        );
    }

    onSelect(key, item, type) {
        const {portalThemeStore} = this.props;

        if(item.url != ''){
            if(item.url== '/spa/document/static/index.html#/main/document/add'
                || item.url== '/spa/document/static/index.html#/main/document/search'
                || item.url== '/spa/workflow/index_mobx.jsp#/main/workflow/add'
                || item.url== '/spa/workflow/index_mobx.jsp#/main/workflow/queryFlowResult'
                || item.url== '/spa/workflow/index_mobx.jsp#/main/workflow/supervise'){
                item.url = item.url + "?menuidforportal=" + "left_" + item.infoId;
            }
            if(item.url && item.url.indexOf('tabTitle') < 0){
                if(item.url && item.url.indexOf('#') != '-1'){
                    let urlArr = item.url.split('#');
                    if(urlArr[1] && urlArr[1].indexOf('?')!= '-1'){
                        item.url = item.url + "&tabTitle=" + item.name;
                    }else {
                        item.url = item.url + "?tabTitle=" + item.name;
                    }
                }else if(item.url && item.url.indexOf('?') != '-1'){
                    item.url = item.url + "&tabTitle=" + item.name;
                }else {
                    item.url = item.url + "?tabTitle=" + item.name;
                }
            }
        }

        portalThemeStore.onLeftMenuSelectedChange(item);
        portalThemeStore.onLoadMain(item);
    }
}

export default E9LeftMenu;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology9/layout4/E9LeftMenu.js